import { forwardRef } from 'react'
import Select, { SelectProps } from '@material-ui/core/Select'
import { FormControl, InputLabel, MenuItem } from 'ui-components-web'

type FormSelectProps = Partial<SelectProps> & {
  label?: string
  value?: any
  options: any[]
  className?: string
  required?: boolean
  getOptionValue?: (o: any) => any
  getOptionLabel: (o: any) => string
}

const FormSelect = forwardRef<any, FormSelectProps>(
  (
    {
      label = '',
      value = '',
      options,
      className = '',
      required = false,
      getOptionValue = (option) => option,
      getOptionLabel = (option) => option,
      ...props
    },
    ref,
  ) => {
    const labelProps: { label?: string } = {}
    if (label) labelProps.label = label
    return (
      <FormControl className={className} required={required} fullWidth>
        <InputLabel variant="outlined">{label}</InputLabel>
        <Select variant="outlined" autoWidth value={options.length ? value : ''} ref={ref} {...props} {...labelProps}>
          {options.map((option, i) => (
            <MenuItem value={getOptionValue(option)} key={i}>
              {getOptionLabel(option)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    )
  },
)
FormSelect.displayName = 'FormSelect'

export default FormSelect
